export default {
  title: 'Modelos de Board',
  description: 'Crie modelos de quadros visuais de trabalho, definindo níveis, tipos de cartão, colunas e status para cada produto e serviço. Os campos são associados aos tipos de card.',

  labels: {
    new: 'Novo modelo',
  },

  form: {
    title: 'Modelo de Board',
  },

  tabs: {
    cardTypes: 'Tipos de card',
    levels: 'Níveis',
    columns: 'Colunas',
  },

  groups: {
    identification: 'Identificação',
  },

  fields: {
    product: 'Produto',
    service: 'Serviço',
    key: 'Identificador',
    purpose: 'Finalidade',
    identifier: 'Nome da Coluna',
    active: 'Ativo',
    position: 'Ordem',
    level: 'Nível',
    name: 'Nome',
    description: 'Descrição',
    associatedCardTypes: 'Tipos de card associados',
    levelName: 'Nome',
    identifier: 'Identificador',
    levelKey: 'Chave',
    icon: 'Ícone',
    color: 'Cor',
    systemKey: 'Função estrutural',
    fieldType: 'Tipo de campo',
    required: 'Obrigatório',
    cardType: 'Tipo de card',
    status: 'Status',
    field: 'Campo',
    row: 'Linha',
    column: 'Coluna',
    columnSpan: 'Largura',
    statusPresentation: 'Apresentação do status nos cards',
  },

  statusPresentation: {
    combo: 'Combo',
    breadcrumb: 'Breadcrumb',
  },

  fieldTypes: {
    text: 'Texto',
    textarea: 'Texto longo',
    number: 'Número',
    date: 'Data',
    boolean: 'Sim/Não',
    combo: 'Lista',
    editor: 'Editor',
  },

  catalog: {
    purposes: {},
    levels: {},
    cardTypes: {
      epic: 'Épico',
      feature: 'Feature',
      story: 'História',
      user_story: 'História de usuário',
      task: 'Tarefa',
      enabler: 'Enabler',
      bug: 'Bug',
      poc: 'PoC',
      technical_debt: 'Dívida técnica',
    },
    fields: {
      assigned_to: 'Responsável',
      story_points: 'Story Points',
      tags: 'Tags',
      parent: 'Pai',
      predecessor: 'Antecessor',
      iteration: 'Iteração',
      due_date: 'Prazo',
    },
    columns: {
      new: 'Novo',
      to_do: 'A fazer',
      in_progress: 'Em andamento',
      review: 'Revisão',
      done: 'Concluído',
      closed: 'Fechado',
    },
    pages: {
      details: 'Detalhes',
    },
    groups: {
      description: 'Descrição',
      deployment: 'Implantação',
      development: 'Desenvolvimento',
      primary: 'Principal',
      related_work: 'Trabalho relacionado',
      secondary: 'Secundário',
      tertiary: 'Complementar',
    },
  },

  levels: {
    title: 'Níveis',
    form: {
      title: 'Cadastro de Nível',
    },
    labels: {
      new: 'Novo nível',
    },
    groups: {
      cardTypes: 'Tipos de card associados',
    },
  },

  levelCardTypes: {
    title: 'Tipos de card do nível',
    form: {
      title: 'Vincular tipo de card',
    },
    labels: {
      new: 'Vincular tipo de card',
    },
  },

  cardTypes: {
    title: 'Tipos de card',
    form: {
      title: 'Tipo de card',
    },
    labels: {
      new: 'Novo tipo de card',
    },
    groups: {
      identification: 'Identificação',
      automaticPages: 'Páginas automáticas do card',
    },
    tabs: {
      statuses: 'Status',
      layout: 'Layout',
    },
  },

  cardPages: {
    attachments: 'Anexos',
    relationships: 'Relacionamentos',
    history: 'Histórico',
  },

  statuses: {
    title: 'Status',
    form: {
      title: 'Status',
    },
    labels: {
      new: 'Novo status',
    },
  },

  layout: {
    actions: {
      addField: 'Adicionar campo',
      createField: 'Criar novo campo',
      addGroup: 'Adicionar grupo',
      addPage: 'Adicionar página',
      newPage: 'Nova página',
      removeField: 'Remover campo',
      removeGroup: 'Remover grupo',
      removePage: 'Remover página',
      changeWidth: 'Alterar largura',
    },
    useExistingField: 'Usar campo existente',
    createNewField: 'Criar novo campo',
    selectExistingField: 'Campo',
    pageIdentifier: 'Identificador da página',
    empty: 'Adicione uma página para começar a montar o layout.',
    emptyGroup: 'Arraste campos aqui ou clique em "+" para adicionar um novo campo.',
    confirmRemoveGroup: 'Este grupo contém campos. Removê-lo também tira esses campos deste layout. Deseja continuar?',
    noGroups: 'Adicione um grupo para organizar os campos desta página.',
    pages: {
      title: 'Páginas',
      form: {
        title: 'Página',
      },
      labels: {
        new: 'Nova página',
      },
      groups: {
        definition: 'Página',
        layoutGroups: 'Grupos',
      },
    },
    groups: {
      title: 'Grupos',
      form: {
        title: 'Grupo',
      },
      labels: {
        new: 'Novo grupo',
      },
      groups: {
        definition: 'Grupo',
        fields: 'Campos',
      },
    },
    fields: {
      title: 'Campos do layout',
      form: {
        title: 'Campo do layout',
      },
      labels: {
        new: 'Adicionar campo ao layout',
      },
    },
  },

  fieldsCatalog: {
    title: 'Campos',
    form: {
      title: 'Campo',
    },
    labels: {
      new: 'Novo campo',
    },
  },

  empty: {
    noLevels: 'Nenhum nível foi criado para este modelo. Crie primeiro um nível na aba Níveis.',
    noLevelSelected: 'Selecione um nível para configurar as colunas.',
  },

  columns: {
    title: 'Colunas',
    form: {
      title: 'Coluna',
    },
    labels: {
      new: 'Nova coluna',
    },
    groups: {
      definition: 'Definição',
      mappings: 'Mapeamento de status',
    },
  },

  mappings: {
    title: 'Mapeamento de status',
    form: {
      title: 'Mapeamento de status',
    },
    labels: {
      new: 'Novo mapeamento',
    },
  },

  systemKeys: {
    none: 'Nenhuma',
    new: 'Nova',
    wait: 'Em espera',
    in_progress: 'Em andamento',
    closed: 'Fechada',
    canceled: 'Cancelada',
  },

  errors: {
    identifierRequired: 'Informe o identificador usado pelo dicionário.',
    fieldTypeInvalid: 'Selecione um tipo de campo válido.',
    duplicateModel: 'Já existe um modelo de Board com esta combinação de produto, serviço e chave.',
    serviceBoardRequired: 'O modelo de Board informado não existe.',
    levelRequired: 'O nível informado é obrigatório.',
    levelNameRequired: 'Informe um nome válido para o nível.',
    levelInvalid: 'O nível informado é inválido.',
    levelNotInModel: 'O nível informado não pertence a este modelo de Board.',
    levelCardTypeRequired: 'Selecione um nível e um tipo de card.',
    levelCardTypeInvalid: 'O tipo de card selecionado não pertence ao mesmo modelo do nível.',
    levelCardTypeInUse: 'Remova os mapeamentos deste tipo de card antes de desvinculá-lo do nível.',
    cardTypeRequired: 'O tipo de card informado não pertence a este modelo de Board.',
    cardTypeNameRequired: 'Informe o nome do tipo de card.',
    cardPageInvalid: 'Selecione uma opção válida para as páginas automáticas do card.',
    columnRequired: 'A coluna informada não pertence a este modelo de Board.',
    statusRequired: 'O status informado não pertence ao tipo de card selecionado.',
    statusNameRequired: 'Informe o nome do status.',
    mappingLevelMismatch: 'O tipo de card precisa pertencer ao mesmo nível da coluna.',
    mappingInvalid: 'O tipo de card, o status e a coluna precisam pertencer ao mesmo modelo e nível.',
    positionInvalid: 'Informe uma ordem válida, maior que zero.',
    levelPositionInUse: 'Este nível não pode ser removido enquanto houver tipos de card ou colunas associados.',
    levelReorderFailed: 'Não foi possível reordenar o nível e as colunas associadas.',
    levelReorderInvalid: 'Não foi possível aplicar a nova ordem dos níveis.',
    levelKeyImmutable: 'A identidade semântica deste nível não pode ser alterada depois da criação.',
    levelActiveInvalid: 'O valor do campo Ativo é inválido.',
    levelInUse: 'Este nível não pode ser removido enquanto houver tipos de card ou colunas associados.',
    cardTypeLevelInUse: 'Remova os mapeamentos deste tipo de card antes de alterar o nível.',
    columnLevelInUse: 'Remova os mapeamentos desta coluna antes de alterar o nível.',
    systemKeyInvalid: 'A função estrutural informada não é válida para uma coluna.',
    structuralColumnLocked: 'A função estrutural de uma coluna estrutural não pode ser alterada.',
    structuralColumnDelete: 'As colunas Nova, Em andamento e Fechada são estruturais e não podem ser removidas.',
    layoutPageRequired: 'A página de layout informada não existe.',
    layoutFieldRequired: 'Selecione um grupo e um campo.',
    layoutFieldInvalid: 'O campo precisa estar disponível para o tipo de card do grupo.',
    layoutPositionInvalid: 'Linha e coluna devem ser zero ou maiores, e a largura deve ser maior que zero.',
    saveModelBeforeColumns: 'Salve o modelo antes de configurar as colunas.',
    saveCardTypeBeforeLayout: 'Salve o tipo de card antes de configurar o layout.',
    columnEditorInvalid: 'A configuração de colunas está inválida.',
    columnEditorLimit: 'O nível ultrapassou o limite de colunas permitido.',
    columnEditorSaveFailed: 'Não foi possível salvar a configuração de colunas.',
    statusPresentationInvalid: 'Selecione uma apresentação de status válida.',
    layoutEditorInvalid: 'A configuração do layout está inválida.',
    layoutEditorSaveFailed: 'Não foi possível salvar o layout.',
    boardTargetInvalid: 'Não foi possível acessar o serviço de Board.',
    columnLoadFailed: 'Não foi possível carregar as colunas.',
    columnSaveFailed: 'Não foi possível salvar as colunas.',
    layoutLoadFailed: 'Não foi possível carregar o layout.',
  },
};
